import { useState } from "react";

import { SVGSprite } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";

import OneOnOneYogaModal from "../OneOnOneYogaModal";

import { classNameGenerator, clsx } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./OneOnOneYogaPricingSection.module.scss";

interface OneOnOneYogaPricingSectionProps {
  light?: boolean;
}

const OneOnOneYogaPricingSection: React.FC<OneOnOneYogaPricingSectionProps> = ({
  light,
}) => {
  const cls = classNameGenerator(styles);

  const [showCallbackModal, setShowCallbackModal] = useState(false);

  const { data } = useAppSelector((state) => state.bootCamp);
  let { label, currencySymbol, price, originalPrice } = data?.pricingData || {};
  let {
    formSection: { label: trialLabel },
    currencySymbol: trialCurrencySymbol,
    price: trialPrice,
  } = data?.trialData || { formSection: {} };
  const isTrialPage = data?.subPageType === "ONE_ON_ONE_YOGA_TRIAL" ? true : false

  return (
    <div
      className={clsx(
        cls("oneOnOneYogaPricingSection"),
        light ? cls("light") : ""
      )}
    >
      <div className={cls("leftSection")}>
        <SVGSprite icon="icon-yoga-callback" className={cls("icon")} />
        <div className={cls("titleWrapper")}>
          <Typography
            variant="paragraph1"
            className={cls("label")}
            dangerouslySetInnerHTML={{ __html: `${label}` }}
          />
          &nbsp;
          <br />
          {currencySymbol && price!==null && <Typography
            variant="paragraph1"
            className={
              isTrialPage ? cls("trialPrice") : cls("price")}
            dangerouslySetInnerHTML={{ __html: `${currencySymbol} ${price}` }}
          />}
          {currencySymbol && originalPrice!==null && <Typography
            variant="paragraph1"
            className={cls("strikeoutPrice")}
            dangerouslySetInnerHTML={{
              __html: `${currencySymbol} ${originalPrice}`,
            }}
          />}
        </div>
      </div>
      <div className={cls("rightSection")}>
        <button
          type="button"
          className={clsx(cls("heroCtaButton"), cls("darkColor"))}
          onClick={() => setShowCallbackModal(true)}
        >
          <span
            className={cls("heroCtaButtonText")}
            dangerouslySetInnerHTML={{
              __html: trialPrice ? `Book a class` : "Request a call back",
            }}
          />
          <span>{arrowIcon}</span>
        </button>
      </div>
      <OneOnOneYogaModal
        showModal={showCallbackModal}
        setShowModal={setShowCallbackModal}
      />
    </div>
  );
};

export default OneOnOneYogaPricingSection;

const arrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M6.5 13L10.5 9L6.5 5"
      stroke="#ffffff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
